import { BankMaster } from './../Model/BankMaster';
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ForgotPassword } from '../Model/ForgotPassword';
import { PartyUser } from '../Model/PartyUser';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor (private _httpClient: HttpClient) { }

  AuthenticatePartyLogin(input: any): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Basic " + btoa(environment.ApiUserName + ":" + environment.ApiPassword));
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "Partylogin/Partylogin", body, httpOptions);
  }

  GETCitys(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "City", httpOptions);
  }

  GETCitysByLocation(input: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "City/" + input, httpOptions);
  }

  GetBankList(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "BankMaster", httpOptions);
  }

  GetLocationBank(input: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "LocationBank/" + input, httpOptions);
  }

  GetLedgerBank(locid: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "LocationBank?intype=0&locid=" + locid, httpOptions);
  }

  GetcityById(input: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "City?id=0&cityId=" + input, httpOptions);
  }

  //=======================================User Branch======================================================
  GetUserBranch(userid: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "UserBranch?id=" + userid, httpOptions);
  }

  UpdateUserBranch(input: any[]): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "UserBranch", body, httpOptions);
  }

  GetUserBranchForAccess(userid: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    return this._httpClient.get(environment.WebserviceUrl + "UserBranch?id=" + userid + "&intype=1", httpOptions);
  }

  GetOTP(input: ForgotPassword): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Basic " + btoa(environment.ApiUserName + ":" + environment.ApiPassword));
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "Partylogin/GetForgotPasswordOTP", body, httpOptions);
  }

  ChangePassword(input: ForgotPassword): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append("Content-Type", "application/json");
    const httpOptions = { headers };
    let body = JSON.stringify(input);
    return this._httpClient.post(environment.WebserviceUrl + "Partylogin/ChangePassword", body, httpOptions);
  }

  ChangePasswordBasic ( input: ForgotPassword ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Basic " + btoa( environment.ApiUserName + ":" + environment.ApiPassword ) );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "Partylogin/ChangePasswordBasic", body, httpOptions );
  }
}
